import {
  createTheme,
  CssBaseline,
  ThemeProvider,
  useTheme,
  useThemeProps,
} from "@mui/material";
import React from "react";
import { useTeamConfig } from "../../components/TeamConfigProvider";
import { Instrument_Sans } from "next/font/google";
import { useSSTheme } from "../../hooks/useSSTheme";

export const InstrumentSansFont = Instrument_Sans({
  subsets: ["latin"],
  preload: true,
  // display: "swap",
});

export const AppThemeProvider = (props: { children: React.ReactNode }) => {
  const teamConfig = useTeamConfig();
  const ssTheme = useSSTheme();

  return (
    <ThemeProvider
      theme={createTheme({
        palette: {
          mode: "light",
          primary: {
            main: ssTheme.colors.teamPrimary || "#212121",
          },
        },
        typography: {
          fontFamily: [
            `${InstrumentSansFont.style.fontFamily}`,
            "-apple-system",
            "Inter",
            "Helvetica",
            "Arial",
            "sans-serif",
          ].join(","),
        },
      })}
    >
      <CssBaseline />
      {props.children}
    </ThemeProvider>
  );
};
